const MONTH_NAMES = [
  'Janeiro',
  'Fevereiro',
  'Março',
  'Abril',
  'Maio',
  'Junho',
  'Julho',
  'Agosto',
  'Setembro',
  'Outubro',
  'Novembro',
  'Dezembro'
]

export const formatCompetenceLabel = (referenceDate: string): string => {
  const date = new Date(referenceDate)
  const month = MONTH_NAMES[date.getUTCMonth()]
  const year = date.getUTCFullYear()

  return `Competência: ${month}/${year}`
}
